export const selectIsLoggedIn = state => state.member?.isLoggedIn;

export const selectGeolocation = state => state.member?.geolocation;

export const selectMemberId = state => state.member?.memberId;
export const selectMemberCountryCodeIso2 = state =>
    state.member?.countryCodeIso2;

export const selectIsOutsideSweden = state =>
    state.member?.geolocation?.isoCode &&
    state.member?.geolocation?.isoCode.toLowerCase() !== 'se';

export const selectIsFetchingGeolocation = state =>
    state.member?.isFetchingGeolocation;
